<template>
  <div>
    <div class="header" :style="{ top: isShowAdvertis ? '0' : '-50px' }">
      <div class="head-banner f-c-c" :style="{ backgroundColor: userId ? adBar.afterBackgroundColor : adBar.beforeBackgroundColor }">
        <span v-if="userId" class="f-c-c" :class="{ pointer: !!adBar.afterLoginLink }" @click="adBarJump('afterLoginLink')">
          <oss-img :src="adBar.afterLoginImg" :height="18" mType="lfit" alt="" />
        </span>
        <span v-else class="f-c-c" :class="{ pointer: !!adBar.beforeLoginLink }" @click="adBarJump('beforeLoginLink')">
          <oss-img :src="adBar.beforeLoginImg" :height="18" mType="lfit" alt="" />
        </span>
      </div>
      <div class="head-main">
        <header class="f-b-c">
          <a :href="`${mainDomain}/mall`" class="logo-img pointer" @click="jump">
            <img src="@/assets/img/logo.png" alt="" />
          </a>
          <div class="right-content f--c">
            <new-search />
            <new-icon-list @showNewFunction="showNewFunction" />
          </div>
        </header>
        <div class="header-nav f-b-c">
          <custom-nav />
          <div class="right f--c">
            <a :href="`${mainDomain}/ai-designer`" class="color-green">Kaka Designer</a>
            <a :href="`${mainDomain}/`" class="pointer color-gray-3">GO TO KAKACLO</a>
          </div>
        </div>
      </div>
    </div>

    <!-- <div v-if="!isPC" class="mobile-header f-b-c">
      <div class="mobile-header-left f--c">
        <i class="iconfont icon-menu-fill" @click="menuShowForMobile = true"></i>
        <img class="mobile-logo" src="@/assets/img/mobile-logo.jpg" @click="jumpHref('/mall')">
      </div>
      <div class="mobile-header-right f-c-c">
        <i v-if="!['/mall', '/','/mall/search'].includes($route.path)" class="iconfont icon-a-search-line1" @click="$router.push('/mall/search')"></i>
        <span v-if="$store.state.common.userName" class="p-r" :style="{ paddingRight: `${String($store.state.common.shoppingCartSkuNum || '').length * .05}rem`}" @click="showShoppingCart">
          <i class="iconfont icon-shangpin-gouwudai"></i>
          <span v-show="$store.state.common.shoppingCartSkuNum > 0" class="mobile-cart-num">{{$store.state.common.shoppingCartSkuNum > 99 ? '99+' : $store.state.common.shoppingCartSkuNum}}</span>
        </span>
        <i class="iconfont icon-fenlei" @click="$refs.productMenu.show()"></i>
      </div>
      <van-popup v-model="menuShowForMobile" position="left" :style="{ width: '70%',height: '100%' }" closeable close-icon-position="top-left">
        <div class="navigationContent">
          <div style="height: calc(100% - 1.5rem)">
            <div class="user">
              <template v-if="$store.state.common.userName">
                <van-icon name="user-o" />
                <span style="margin-left: .3rem">{{$store.state.common.userName}}</span>
              </template>
              <el-button v-else style="width:100%" type="primary" @click="navigageClick('/login', 518)">{{$t('headerBar.login')}}</el-button>
            </div>
            <van-collapse v-model="homeActiveForMobile" class="myCompany">
              <van-collapse-item :title="$t('headerBar.home')" name="1">
                <custom-nav></custom-nav>
              </van-collapse-item>
            </van-collapse>
            <van-collapse v-model="companyActiveForMobile" class="myCompany">
              <van-collapse-item :title="$t('headerBar.company')" name="1">
                <div class="itemContent" @click="navigageClick('/home')" :class="{ activeM: routerPath === '/home' }">Go to kakaclo</div>
                <div class="itemContent" @click="navigageClick('/help-center')" :class="{ activeM: routerPath === '/help-center' }">{{ $t('headerBar.helpCenter') }}</div>
              </van-collapse-item>
            </van-collapse>
            <template v-if="$store.state.common.userName">
              <div class="navigate f fw-w" style="margin-top: .1rem">
                <div @click="navigageClick('/publish/productList', 520)" :class="{ activeM: routerPath === '/publish/productList' }" style="width: 100%">{{$t('headerBar.wishList')}}</div><br>
                <div @click="navigageClick('/publish/listings', 521)" :class="{ activeM: routerPath === '/publish/listings' }" style="width: 100%">{{$t('headerBar.listing')}}</div><br>
                <div @click="navigageClick('/order/list', 522)" :class="{ activeM: routerPath === '/order/list' }" style="width: 100%">{{$t('headerBar.allOrder')}}</div><br>
              </div>
            </template>
          </div>
          <div  v-if="$store.state.common.userId" class="logout f-c-c" @click="logOut">
            {{$t('headerBar.logOut')}}
          </div>
        </div>
      </van-popup>
      <product-menu ref="productMenu"></product-menu>
    </div>
    <div v-else class="header f--c fixed" :style="{ top: isShowAdvertis ?  '0' : '-50px' }">
      <div class="head-banner f-c-c" :style="{ backgroundColor: $store.state.common.userId ? adBar.afterBackgroundColor : adBar.beforeBackgroundColor }">
        <span v-if="$store.state.common.userId" class="f-c-c" :class="{ pointer: !!adBar.afterLoginLink }" @click="adBarJump('afterLoginLink')"><oss-img :src="adBar.afterLoginImg" :height="18" mType="lfit" /></span>
        <span v-else class="f-c-c" :class="{ pointer: !!adBar.beforeLoginLink }" @click="adBarJump('beforeLoginLink')"><oss-img :src="adBar.beforeLoginImg" :height="18" mType="lfit" /></span>
      </div>
      <header class="f-b-c">
        <router-link to="/"><img src="@/assets/img/logo.png" /></router-link>
        <custom-search ref="customSearch" @search="customSearch" @showUploadPopout="showUploadPopout" />
        <template v-if="$store.state.common.userName">
          <div class="user f--c">
            <div class="notice f--c">

              <div class="pointer" style="margin-right:14px" @click="handleMenu({ path:'/help-center' })">
                <el-tooltip class="item" effect="dark" :content="$t('headerBar.helpCenter')" placement="top-start">
                  <i class="iconfont icon-help pointer" style="font-size:20px;"></i>
                </el-tooltip>
              </div>
              <div class="pointer" style="margin-right:14px" @click="$router.push('/mall/shipping-cost')">
                <el-tooltip class="item" effect="dark" content="Shipping Calculation" placement="top-start">
                  <i class="iconfont icon-wuliu" style="font-size:23px"></i>
                </el-tooltip>
              </div>
              <div class="pointer">
                <el-popover placement="bottom-end" width="500" :offset="230" trigger="click">
                  <inform-box @showNewFunction="showNewFunction" />
                  <el-badge slot="reference" :is-dot="$store.state.common.newFunctionIsRead" class="item">
                    <i class="el-icon-bell" style="font-size:22px"></i>
                  </el-badge>
                </el-popover>
              </div>
              <div class="f--c pointer" style="margin-left:20px" @click="showShoppingCart">
                <i class="iconfont icon-shangpin-gouwudai" style="font-size:20px"></i>
                <span style="margin-top:-1px;margin-left:2px">{{$store.state.common.shoppingCartSkuNum > 99 ? '99+' : $store.state.common.shoppingCartSkuNum}}</span>
              </div>
              <el-popover
                placement="bottom"
                trigger="click">
                <i class="iconfont icon-dollar pointer" style="font-size: 20px;margin-left: 14px" slot="reference"></i>
                <h5 style="margin:10px 0">{{ $t('Index.Components.Header.Currency') }}</h5>
                <el-select v-model="internationalParams.currency">
                  <el-option value="USD" label="USD-$"></el-option>
                  <el-option value="EUR" label="EUR-€"></el-option>
                  <el-option value="RUB" label="RUB-₽"></el-option>
                  <el-option value="CNY" label="CNY-¥"></el-option>
                  <el-option value="GBP" label="GBP-£"></el-option>
                  <el-option value="AUD" label="AUD-A$"></el-option>
                </el-select>
                <div class="f-c-c" style="margin-top: 10px">
                  <el-button type="primary" style="width:90%;" @click="saveInternational">{{ $t('Index.Components.Header.Save') }}</el-button>
                </div>
              </el-popover>
            </div>
            <el-dropdown v-show="$store.state.common.userName" @command="handleCommand">
              <span class="el-dropdown-link f-c-c">
                <div class="avatar f-c-c">{{ firstName }}</div>
                <div class="ellipsis" style="max-width:100px">{{ $store.state.common.userName }}</div>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="1">{{$t('headerBar.wishList')}}</el-dropdown-item>
                <el-dropdown-item :command="2">{{$t('headerBar.listing')}}</el-dropdown-item>
                <el-dropdown-item :command="3">{{$t('headerBar.allOrder')}}</el-dropdown-item>
                <el-dropdown-item :command="4">{{ $t('Index.Components.Header.PersonalCenter') }}</el-dropdown-item>
                <el-dropdown-item :command="5">{{$t('headerBar.logOut')}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
        <template v-else>
          <div class="f--c">
            <div class="pointer" @click="$router.push('/mall/shipping-cost')">
              <el-tooltip class="item" effect="dark" content="Shipping Calculation" placement="top-start">
                <i class="iconfont icon-wuliu" style="font-size:23px"></i>
              </el-tooltip>
            </div>
            <el-popover
              placement="bottom"
              trigger="click">
              <i class="iconfont icon-dollar pointer" style="font-size: 20px;margin: 0 14px" slot="reference"></i>
              <h5 style="margin:10px 0">{{ $t('Index.Components.Header.Currency') }}</h5>
              <el-select v-model="internationalParams.currency">
                <el-option value="USD" label="USD-$"></el-option>
                <el-option value="EUR" label="EUR-€"></el-option>
                <el-option value="RUB" label="RUB-₽"></el-option>
                <el-option value="CNY" label="CNY-¥"></el-option>
                <el-option value="GBP" label="GBP-£"></el-option>
                <el-option value="AUD" label="AUD-A$"></el-option>
              </el-select>
              <div class="f-c-c" style="margin-top: 10px">
                <el-button type="primary" style="width:90%;" @click="saveInternational">{{ $t('Index.Components.Header.Save') }}</el-button>
              </div>
            </el-popover>
            <div class="login pointer" @click="jump('/login', 518)">{{$t('headerBar.login')}}</div>
            <div class="register f-c-c pointer" @click="jump('/register', 519)">{{$t('headerBar.register')}}</div>
          </div>
        </template>
      </header>
      <div class="navigate f-b-c">
        <div class="left f">
          <div class="f">
            <custom-nav />
          </div>
        </div>
        <div class="right f--c">
          <div v-for="t in menu" :key="t.title" class="item pointer" :class="{ active: routerPath === t.path }" @click="handleMenu(t)">
            <el-dropdown v-if="t.title === 'headerBar.company'" @command="handleCompanyCommand" placement="bottom" :tabindex="1">
              <span class="el-dropdown-link pointer" :class="{ active: ['/dropshipping', '/about-us', '/blog'].includes(routerPath) }">
                {{ $t('headerBar.company') }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" style="width:140px;">
                <el-dropdown-item v-for="d in t.children" :key="d.title" :command="d.path" style="height:40px;line-height:40px;">{{ $t(d.title) }}</el-dropdown-item>
                <el-dropdown-item style="height:40px;line-height:40px;">
                  <a class="blog-item" href="https://kakacloblog.webflow.io/" target="_blank">{{ $t('headerBar.blog') }}</a>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <div v-else-if="t.title === 'AI'">
              <img style="width:122px;height:24px;" src="https://img.kakaclo.com/web-img/home/ai/logo_ai2.png" alt="">
            </div>
            <span v-else>{{ t.path === '/home' ? 'GO to kakaclo' : $t(t.title) }}</span>
          </div>
        </div>
      </div>
      <div v-show="categoryVisible||hoverVisible" id="category" class="category-box" :style="{ height: categoryHeight+'px', bottom: -categoryHeight+'px' }"  @mouseover="mouseover" @mouseout="mouseout">
        <div class="category">
          <category @toProductList="toProductList" @clientHeight="clientHeight" />
        </div>
      </div>
    </div> -->
    <!-- 站内信 新功能查看 -->
    <new-function v-if="$store.state.common.userName" ref="newFunction" />
    <!-- 购物车 -->
    <shopping-cart ref="shoppingCart" />
    <!-- 上传弹框 -->
    <upload-popout ref="uploadPopout" />
    <whats-app />

    <div v-if="isPC">
      <ad-popup />
    </div>
  </div>
</template>

<script>
import API from '@/api'
import newFunction from '@/components/newFunction.vue'
import ShoppingCart from '@/components/ShoppingCart.vue'
// import Photograph from './Photograph.vue'
import Search from '@/views/commodity/components/Search.vue'
import icon from 'vant/lib/icon'
import 'vant/lib/icon/style'
// import badge from 'vant/lib/badge'
// import 'vant/lib/badge/style'
import popup from 'vant/lib/popup'
import 'vant/lib/popup/style'
import Collapse from 'vant/lib/collapse'
import 'vant/lib/collapse/style'
import CollapseItem from 'vant/lib/collapse-item'
import 'vant/lib/collapse-item/style'
import TreeSelect from 'vant/lib/tree-select'
import 'vant/lib/tree-select/style'
import bus from '@/util/bus'
import UploadPopout from './UploadPopout.vue'
import OssImg from '../../../components/OssImg.vue'
import Category from '@/views/index/components/Category.vue'
import WhatsApp from '../../../components/WhatsApp.vue'
import InformBox from '../../../components/InformBox.vue'
import AdPopup from '../../../components/AdPopup.vue'
import CustomNav from './customNav.vue'
import ProductMenu from '../../../components/mobile/ProductMenu.vue'
import NewSearch from '../../../components/NewSearch.vue'
import NewIconList from '../../../components/NewIconList.vue'
// import language from '@/config/language.js'
// import { languageMap } from '@/config/languageMap.js'
export default {
  data() {
    return {
      mainDomain: process.env.VUE_APP_MAIN_DOMAIN,
      input: undefined,
      navigate: [
        // { title: 'headerBar.newIn', path: '/mall/new-in', event_id: 526 },
        // { title: 'headerBar.bestSellers', path: '/mall/sale', event_id: 527 },
        { title: 'headerBar.newIn', path: '/mall/album', event_id: 526, type: 1, query: undefined },
        { title: 'headerBar.bestSellers', path: '/mall/album', event_id: 527, type: 2, query: undefined },
        { title: 'headerBar.specialOffer', path: '/mall/discount', event_id: 528 },
        { title: 'headerBar.fashionTrends', path: '/mall/explore', type: 'hot', event_id: 529 }
      ],
      // menu: [
      //   { title: 'headerBar.whyUs', path: '/home', code: 6 },
      //   { title: 'headerBar.dropshipping', path: '/dropshipping', code: 8 },
      //   { title: 'headerBar.helpCenter', path: '/help-center', code: 7 },
      //   { title: 'headerBar.company', path: '', children: [
      //     { title: 'headerBar.aboutUs', path: '/about-us' }
      //   ]
      //   }
      // ],
      menu: [
        // { title: 'headerBar.helpCenter', path: '/help-center', event_id: 530 },
        { title: 'AI', path: '/ai-designer' },
        { title: 'Go to kakaclo', path: '/home', event_id: 531 }
      ],
      menuShowForMobile: false,
      companyActiveForMobile: ['1'],
      homeActiveForMobile: ['1'],
      categoryVisibleForMobile: false,
      categoryTreeActive: 0,
      categoryTreeOptions: [{ text: '分组 1' }, { text: '分组 2' }],
      internationalParams: {
        currency: 'USD',
        language: undefined
      },
      categoryVisible: false,
      categoryHeight: 680,
      isHaveBackTop: false,
      hoverVisible: false, // 鼠标移入
      christmasDisCountId: [],
      halloweenDisCountId: []
    }
  },
  components: {
    newFunction,
    ShoppingCart,
    'custom-search': Search,
    'van-icon': icon,
    // 'van-badge': badge,
    'van-popup': popup,
    'van-collapse': Collapse,
    'van-collapse-item': CollapseItem,
    'van-tree-select': TreeSelect,
    UploadPopout,
    OssImg,
    Category,
    WhatsApp,
    InformBox,
    AdPopup,
    CustomNav,
    ProductMenu,
    NewSearch,
    NewIconList
  }, // Photograph,
  computed: {
    isActive() {
      return (t) => {
        let _router = this.$route
        if (t.query) {
          return !!(_router.path === t.path && +_router.query.type === +t.query.type)
        } else if (_router.path === t.path) {
          return true
        } else {
          return false
        }
      }
    },
    albumTopList() {
      return this.$store.state.common.albumTopList
    },
    adBar() {
      return this.$store.state.common.adBar
    },
    festivaiList() {
      return this.$store.state.common.festivaiActivity
    },
    routerPath() {
      return this.$route.path
    },
    firstName() {
      return this.$store.state.common.userName && this.$store.state.common.userName[0].toUpperCase()
    },
    isShowAdvertis() {
      return this.$store.state.isShowAdvertis
    },
    categoryTree() {
      const categoryTree = this.$store.state.common.categoryTree
      if (categoryTree.length === 0) this.$store.dispatch('common/getCategoryTree')
      categoryTree.forEach(e => {
        e.text = e.name
        if (e.childList) {
          e.childList.forEach(ee => (ee.text = ee.name))
        }
      })
      return categoryTree
    },
    categoryTreeActiveTree() {
      const target = this.categoryTree[this.categoryTreeActive] || { childList: [] }
      return target.childList
    },
    languageSelectList() {
      const languageList = [
        { value: 'en', name: 'English', img: require('@/assets/img/languages/en.png') },
        { value: 'ru-RU', name: 'русский язык', img: require('@/assets/img/languages/ru-RU.png') },
        { value: 'fr-FR', name: 'Français', img: require('@/assets/img/languages/fr-FR.png') },
        { value: 'de', name: 'Deutsch', img: require('@/assets/img/languages/de.png') },
        { value: 'pt-PT', name: 'Português', img: require('@/assets/img/languages/pt-PT.png') },
        { value: 'es-ES', name: 'Español', img: require('@/assets/img/languages/es-ES.png') },
        { value: 'zh-CN', name: '中文', img: require('@/assets/img/languages/zh-CN.png') }
      ]
      return languageList
    },
    userId() {
      return this.$store.state.common.userId
    }
  },
  created() {
    this.getAdvertisingBar()
    this.getUserCurrency()
    // this.getFestivaiActivity() 老导航
    // this.getAlbumModuleTop() 老导航
  },
  mounted() {
    // this.$showAdvertis && window.addEventListener('scroll', () => {
    //   let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    //   if (this.isShowAdvertis !== scrollTop <= 0) {
    //     this.$store.commit('set', { isShowAdvertis: scrollTop <= 0 })
    //   }
    // })
    const category = document.querySelector('#category')
    const categoryTab = document.querySelector('#categoryTab')
    const clickCategory = (e) => {
      if (this.categoryVisible && !category.contains(e.target) && !categoryTab.contains(e.target)) {
        this.categoryVisible = false
      }
    }
    document.addEventListener('click', clickCategory)
    this.$once('hook:beforeDestroy', () => {
      document.removeEventListener('click', clickCategory)
    })
  },
  methods: {
    // 节日折扣产品
    // getFestivalSaleList() {
    //   API.getDiscountList({
    //     pageNumber: 1,
    //     pageSize: 3,
    //     type: 3,
    //     status: 1,
    //     sortType: 3
    //   }).then(({ data }) => {
    //     this.festivalSaleList = data.list
    //     if (data.list && data.list.length) {
    //       this.christmasDisCountId = data.list.filter(item => item.discountName.toLowerCase().indexOf('christmas') > -1)
    //       this.halloweenDisCountId = data.list.filter(item => item.discountName.toLowerCase().indexOf('halloween') > -1)
    //     }
    //   })
    // },
    customSearch(searchText) {
      const router = {
        path: '/product-list'
      }
      if (searchText) router.query = { search: searchText }
      // this.$router.push(router)
      location.href = `${router.path}?search=${searchText}`
    },
    handleActive(t) {
      if (t.path) {
        if (t.query) this.$router.push({ path: t.path, query: t.query })
        else this.$router.push(t.path)
      }
    },
    jumpFestivai(t) {
      this.$router.push({
        path: '/mall/festival-collection',
        query: { discountId: t.discountId }
      })
    },
    handleMenu(t) {
      // sharingLogin()
      window.open(process.env.VUE_APP_MAIN_DOMAIN + (t.path.includes('/home') ? (process.env.NODE_ENV === 'production' ? '' : '/home') : t.path))
    },
    handleCommand(command) {
      switch (command) {
        case 1:
          this.$router.push('/publish/productList')
          return
        case 2:
          this.$router.push('/publish/listings')
          return
        case 3:
          this.$router.push('/order/list')
          return
        case 4:
          this.$router.push('/personal-center/account-setting')
          return
        case 5:
          this.logOut()
          return
        case 6:
          this.$router.push('/mall/shipping-cost')
      }
    },
    handleCompanyCommand(command) {
      this.$router.push(command)
    },
    logOut() {
      API.logout().finally(() => {
        this.$store.dispatch('logOut')
      })
    },
    showNewFunction(tabs, id) {
      this.$refs.newFunction.show(tabs, id)
    },
    showShoppingCart() {
      // console.log(this.$refs)
      // this.$refs.shoppingCart.show()
      if (this.isPC) this.$router.push('/mall/shoppingCar')
      else {
        this.$router.push('/mall/mobileCart')
        // this.$refs.shoppingCart.show()
      }
    },
    navigageClick(path, event_id, t) {
      if (t) {
        if (t.query) this.$router.push({ path: t.path, query: t.query })
        else this.$router.push(t.path)
      } else this.$router.push(path)
      this.menuShowForMobile = false
    },
    showUploadPopout() {
      this.$refs.uploadPopout.show()
    },
    jump(path, event_id) {
      this.$router.push({ path })
    },
    jumpHref(path) {
      location.href = path
    },
    saveInternational() {
      this.$i18n.locale = this.internationalParams.language
      this.$store.commit('set', { language: this.internationalParams.language })
      const params = {
        currencyCode: 'USD',
        forCurrency: this.internationalParams.currency
      }
      if (this.$store.state.common.userName) {
        API.setUserBehavior({ type: 2, content: JSON.stringify({
          currency: this.internationalParams.currency,
          language: this.$i18n.locale
        }) })
      }
      this.$store.dispatch('common/getCategoryTree').then(() => {
        API.getCurrencyRate(params).then(res => {
          const currencySymbolMap = {
            'USD': '$',
            'EUR': '€',
            'RUB': '₽',
            'CNY': '¥',
            'GBP': '£',
            'AUD': 'A$'
          }
          const state = {
            currencyRate: res.data,
            currency: this.internationalParams.currency,
            currencySymbol: currencySymbolMap[this.internationalParams.currency]
          }
          this.$store.commit('common/set', state)
          this.$router.go(0)
        })
      })
    },
    getUserCurrency() {
      this.internationalParams.language = this.$store.state.language || 'en'
      if (this.$store.state.common.userName) {
        API.getUserBehavior({ type: 2 }).then(res => {
          if (!res.data) return
          const content = JSON.parse(res.data)
          this.internationalParams.currency = content.currency
          // this.$i18n.locale = content.language
          // this.$i18n.locale = JSON.parse(localStorage.getItem('vuex')).language
          this.$store.commit('common/set', { currency: content.currency })
          API.getCurrencyRate({ currencyCode: 'USD', forCurrency: content.currency }).then(res2 => {
            this.$store.commit('common/set', { currencyRate: res2.data })
          })
          // 更新币种符号
          const currencySymbolMap = {
            'USD': '$',
            'EUR': '€',
            'RUB': '₽',
            'CNY': '¥',
            'GBP': '£',
            'AUD': 'A$'
          }
          this.$store.commit('common/set', { currencySymbol: currencySymbolMap[content.currency] })
        })
      }
      if (this.$store.state.common.currency) this.internationalParams.currency = this.$store.state.common.currency
    },
    clientHeight(e) {
      this.categoryHeight = e
    },
    handleCategory() {
      this.categoryVisible = !this.categoryVisible
    },
    mouseover() {
      this.hoverVisible = true
    },
    mouseout() {
      this.hoverVisible = false
    },
    toProductList() {
      this.categoryVisible = false
      this.hoverVisible = false
    },
    // 获取商城广告栏
    getAdvertisingBar() {
      this.$store.dispatch('common/getAdvertisingBar')
    },
    adBarJump(type) {
      if (!this.adBar[type]) {
        return
      }
      const website = this.$store.state.website
      let url = website.filter(t => this.adBar[type].includes(t))
      if (url.length) {
        // url = this.adBar[type].split(url[0])[1]
        // this.$router.push(url)
        location.href = this.adBar[type]
      } else window.open(this.adBar[type])
    },
    // 节日活动
    getFestivaiActivity() {
      this.$store.dispatch('common/getFestivaiActivity')
    },
    // header栏专辑
    getAlbumModuleTop() {
      this.$store.dispatch('common/getAlbumModuleTop').then(res => {
        this.navigate.forEach(item => {
          this.albumTopList.forEach(t => {
            if (item.title.includes('newIn') && t.type === 1) {
              this.$set(item, 'query', { type: t.type, moduleId: t.moduleId })
            }
            if (item.title.includes('bestSellers') && t.type === 2) {
              this.$set(item, 'query', { type: t.type, moduleId: t.moduleId })
            }
          })
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  background-color: #fff;
  flex-direction: column;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
  transition: all .4s;
  overflow: hidden;
  color: #303133;
  transition: all 0.4s;
  position: fixed;
  z-index: 1000;
  .head-banner {
    height: 48px;
    background-color: #1A1717;
    width: 100%;
    overflow: hidden;
  }
  .head-main {
    max-width: 1920px;
    margin: 0 auto;
  }
  header {
    box-sizing: border-box;
    padding: 14px 24px 0px 24px;

    .logo-img {
      // width: 254px;
      // height: 34px;
      img {
        height: 44px;
      }
    }

    .icon_img {
      display: block;
    }

    >div {
      flex-shrink: 0;
    }
    .right-content {
      margin-left: 24px;
      flex: 1;
      display: flex;
      justify-content: flex-end;
    }
  }
  .header-nav {
    padding: 0 24px 10px;
    .right {
      padding-top: 12px;
      a {
        padding: 0 12px;
      }
    }
  }
}
@media screen and (max-width: 1300px) {
  .header {
    .head-main {
      .header-nav {
        .right {
          a:first-child{
            display: none;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1180px) {
  .header {
    .head-main {
      .header-nav {
        .right {
          display: none;
        }
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .header {
    top: 0 !important;
    .head-banner, .header-nav {
      display: none;
    }
    header {
      padding: 14px 16px;
      .right-content {
        margin-left: 12px;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
/**.header {
  width: 100%;
  background-color: #fff;
  flex-direction: column;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
  transition: all .4s;

  .head-banner {
    height: 48px;
    background-color: #1A1717;
    width: 100%;
  }

  >header, >.navigate {
    max-width: 1400px;
    min-width: 1000px;
    width: 100%;
    padding: 0 15px;
  }

  header {
    height: 75px;

    img {
      // width: 254px;
      // height: 34px;
      height: 38px;
    }

    >div {
      flex-shrink: 0;
    }

    .search {
      max-width: 720px;
      min-width: 510px;
      width: 50vw;
      height: 44px;
      margin-left: 3vw;
      margin-right: .5vw;
      border-radius: 44px;
      background: #F5F7F7;
      position: relative;

      .input {
        position: absolute;
        width: 90.5%;

        img {
          width: 26px;
          height: 22px;
        }

        /deep/ .el-input--medium .el-input__inner {
          height: 44px;
          width: 100%;
          border: unset;
          background-color: unset;
        }
      }

      .icon {
        position: absolute;
        right: 0;
        width: 44px;
        height: 44px;
        border-radius: 50%;
        background-color: #99C41C;

        i {
          color: #fff;
          font-size: 19px;
        }
      }
    }

    .user {
      .notice {
        padding-right: 18px;
        margin-right: 18px;
        height: 30px;
        border-right: 1px solid #CDD4DD;
      }

      .avatar {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: #99C41C;
        color: #fff;
        font-size: 14px;
        margin-right: 10px;
      }
    }

    .register {
      // width: 174px;
      padding: 0 31px;
      height: 40px;
      margin-left: .8vw;
      border-radius: 40px;
      background-color: #99C41C;
      color: #fff;
    }
  }

  .navigate{
    height: 40px;
    .left {
      height: 100%;
      .item {
        flex-shrink: 0;
        height: 100%;
        margin-right: 30px;
        color: #10141D;
        padding-top: 6px;
        position: relative;
      }
      .active {
        border-bottom: 4px solid #000;
        color: #000;
        font-size: 16px;
      }
      .hot {
        width: 28px;
        height: 16px;
        position: absolute;
        top: -3px;
        right: -24px;
      }
    }

    .right {
      .item {
        flex-shrink: 0;
        margin-left: 40px;
      }
      .active {
        color: #99C41C;
      }
    }
  }

  .category-box {
    position: absolute;
    width: 100%;
    // height: 680px;
    // bottom: -680px;
    min-height: 340px;
    left: 0;
    right: 0;
    margin: auto;
    background-color: #fff;
    box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.25);
    .category{
      max-width: 1400px;
      min-width: 1000px;
      margin: auto;
    }
  }
}
.fixed {
  position: fixed;
  z-index: 1000;
}
.blog-item{
  color: #606266;
    font-size: 14px;
    text-decoration: none;
    display: inline-block;
    width: 100%;
}
.blog-item:hover{
  color: #99C41C;
}
.mobile-header{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100vw;
  height: 0.86rem;
  padding: 0 0.3rem;
  background: white;
  z-index: 1999;
  .icon-menu-fill{
    font-size: 0.46rem;
    margin-right: 0.22rem;
  }
  .mobile-logo{
    width: 2.07rem;
    height: 0.45rem;
  }
  .mobile-header-right{
    .icon-a-search-line1 {
      font-size: 0.42rem;
      margin-right: 0.2rem;
    }
    .mobile-cart-num{
      position: absolute;
      top: -0.12rem;
      left: 0.25rem;
      background: #AB1E1A;
      line-height: .2rem;
      text-align: center;
      border-radius: 10px;
      color: white;
      padding: .02rem .05rem;
      font-size: .24rem;
    }
    .icon-shangpin-gouwudai{
      font-size: 0.4rem;
    }
    .icon-fenlei{
      font-size: 0.48rem;
      margin-left: 0.2rem;
    }
  }
  .navigationContent {
    padding-top: 60px;
    position: relative;
    // height: 100vh;
    box-sizing: border-box;
    overflow: hidden;
    height: 100%;
    >div{
      height: 100%;
      overflow: auto;
    }
    .logout {
      position: absolute;
      width: 3rem;
      height: .7rem;
      border: 1px solid #B6B6B6;
      color: #B6B6B6;
      font-size: .28rem;
      bottom: .4rem;
      left: 0;
      right: 0;
      margin: auto;
      border-radius: .12rem;
      z-index: 10000;
    }
    .user {
      padding: 0 .3rem;
      font-weight: bold;
      margin-bottom: .3rem;
      /deep/.van-icon {
        font-size: .4rem;
        font-weight: bold;
      }
    }
    .navigate {
      padding: 0 .3rem;
      >div {
        font-weight: bold;
        padding: .1rem .2rem .1rem 0;
        width: 50%;
        margin-bottom: .2rem;
        border-bottom: 1px solid transparent;
        font-size: .25rem;
      }
      .activeM {
        border-bottom: 2px solid #000;
        color: #000;
      }
    }
    .myCompany {
      .itemContent {
        padding: .1rem .3rem;
        border-bottom: 2px solid transparent;
      }
      .activeM {
        border-bottom: 2px solid #000;
        color: #000;
      }
      /deep/.van-cell__title {
        font-weight: bold;
      }
    }
    /deep/.van-hairline--top-bottom::after {
      border: none !important;
    }
    /deep/.van-hairline-unset--top-bottom::after {
      border: none !important;
    }
  }
}

.mobileHeader {
  background-color: #fff;
  padding: .1rem .3rem;
  font-size: .4rem;
}
@media screen and (max-width:1180px) {
  .right{
    display: none;
  }
}
@media screen and (max-width:1300px) {
  .right .item:first-child{
    display: none;
  }
}
*/
</style>
